import styled from 'styled-components';
import type { ProductPageViewModel } from 'autogen/swagger/all';
import Layout from 'components/Layout';
import ProductAccordion from 'components/product/accordion/ProductAccordion';
import ProductItemGallery from 'components/product/ProductItemGallery/ProductItemGallery';
import { breakpoint, sizes } from 'variables';
import MidSection from './components/MidSection/MidSection';
import StyledProductRecommendationLoader from './shared/styles';

const StyledProductAccordion = styled(ProductAccordion)`
    ${breakpoint.up(sizes.lg)} {
        margin-left: 104px;
    }
`;

export default function ChanelProductPage({ model }: { model: ProductPageViewModel }) {
    const { productInformation, recommendationRequest, emaLogo } = model;
    const { productMedia, splashes } = productInformation;

    return (
        <Layout.Page>
            {/* Product Information */}
            <Layout.Section.Tight columns={{ xs: 1, lg: 2 }}>
                <ProductItemGallery items={productMedia} splashes={splashes} emaLogo={emaLogo} />
                <MidSection model={productInformation} />
            </Layout.Section.Tight>

            {/* Product Accordion */}
            <Layout.Section.Tight>
                <StyledProductAccordion model={productInformation} />
            </Layout.Section.Tight>

            {/* Product Recommendation */}
            {recommendationRequest && (
                <Layout.Section.Tight>
                    <StyledProductRecommendationLoader model={recommendationRequest?.recommendationRequest} />
                </Layout.Section.Tight>
            )}
        </Layout.Page>
    );
}
